module.exports = __webpack_public_path__ + "6ffcb8030fb318251299380a1bcd48f6.svg";